import { ChangeEvent } from 'react';
import { parseDate } from '@visalex/core/lib/parseDate';

import isAfter from 'date-fns/isAfter';
import isValid from 'date-fns/isValid';

import { RangeChangeMeta } from './types';

export const handleFromChangeRange = (e: ChangeEvent<HTMLInputElement>, meta: RangeChangeMeta) => {
  const { selectedRange, setFromValue, setSelectedRange, dateFormat } = meta;

  setFromValue(e.target.value);
  const date = parseDate(e.target.value, dateFormat);

  if (!date || !isValid(date)) {
    return setSelectedRange({ from: undefined, to: undefined });
  }

  if (selectedRange?.to && isAfter(date, selectedRange.to)) {
    setSelectedRange({ from: selectedRange.to, to: date });
  } else {
    setSelectedRange({ from: date, to: selectedRange?.to });
  }
};
